module.exports = __webpack_public_path__ + "static/img/015.812378c7.jpg";